module.exports = __webpack_public_path__ + "static/scale-model-of-seattle-ballooning-in-kent-washington-2d4dec4797d5fb1597f6b7a40e19f349.png";